import React from 'react';
import styles from './DeleteItineraryModal.module.css';
import { useTranslation } from 'react-i18next';
import { MapModal } from '../Components/MapModal/MapModal';
import { AnimatedButton } from '../AnimatedButton';

interface DeleteItineraryModalProps {
  onClose: () => void;
  onDelete: () => void;
  itineraryName: string;
}

export const DeleteItineraryModal: React.FC<DeleteItineraryModalProps> = ({
  onClose,
  onDelete,
  itineraryName,
}) => {
  const { t } = useTranslation();

  return (
    <MapModal onClose={onClose}>
      <h2 className={styles.title}>
        {t('Are you sure you want to delete "{{name}}"?', { name: itineraryName })}
      </h2>
      <div className={styles.buttonContainer}>
        <AnimatedButton
          className={styles.deleteButton}
          onClick={onDelete}
          clickedClassName={styles.clicked}
        >
          {t('Yes')}
        </AnimatedButton>
        <AnimatedButton
          className={styles.cancelButton}
          onClick={onClose}
          clickedClassName={styles.clicked}
        >
          {t('No')}
        </AnimatedButton>
      </div>
    </MapModal>
  );
};
